import * as moment from 'moment';

export class DateOnlyFormatValueConverter {
    toView(value: Date) {
        return moment.utc(value).format('M/D/YYYY');
    }
}